import {FC} from 'react'

import {SkeletonBlock} from '@/components/common/skeleton/SkeletonBlock'
import {SkeletonLoadingOverlay} from '@/components/common/skeleton/SkeletonLoadingOverlay'

// Mirrors the stars TrustBox: the rating word, five star tiles and the Trustpilot logo.
export const TrustpilotStarsSkeleton: FC = () => (
  <>
    <SkeletonLoadingOverlay borderRadius={4}>
      <div className="skeleton">
        <SkeletonBlock width={76} height={12} />
        <div className="stars">
          {Array.from({length: 5}).map((_, i) => (
            <SkeletonBlock key={i} width={19} height={19} borderRadius={2} />
          ))}
        </div>
        <SkeletonBlock width={70} height={12} />
      </div>
    </SkeletonLoadingOverlay>

    <style jsx>{`
      .skeleton {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .stars {
        display: flex;
        gap: 2px;
      }
    `}</style>
  </>
)
